<template>
  <div class="loop-item" :class="{'gift-cart': item.meta['gift-cart']!='0'}">
    <ul class="item-actions">
      <li @click="favorite()">
        <i :class="{'icon-favorited': favorited, 'icon-favorite': !favorited}"></i>
      </li>
    </ul>
    <div class="item-image">
      <router-link :to="$i18nRoute({name: 'product', params: {product: item.id}})">
        <img :src="item.image" alt />
      </router-link>
    </div>
    <h3 :class="{'has-badge': item.badge}">
      <span>{{item.title}}</span>
    </h3>
    <div class="item-price" v-html="item.price_html"></div>
  </div>
</template>

<script>
export default {
  props: ['item'],
  data () {
    return {
      favorited: false
    }
  },
  created () {
    this.favorited = this.$store.getters.getFavoriteItem(this.item.id) ? true : false
  },
  methods: {
    favorite () {
      this.$store.dispatch('fetchFavoriteItem', this.item.id)
      this.favorited = this.$store.getters.getFavoriteItem(this.item.id) ? true : false
    }
  }
}
</script>
